import { render } from "./spostaPrenotazioneModal.vue?vue&type=template&id=8f68ff2c&scoped=true&ts=true"
import script from "./spostaPrenotazioneModal.vue?vue&type=script&lang=ts"
export * from "./spostaPrenotazioneModal.vue?vue&type=script&lang=ts"

import "./spostaPrenotazioneModal.vue?vue&type=style&index=0&id=8f68ff2c&scoped=true&lang=css"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f68ff2c"]])

export default __exports__